import { LinkBase, Text } from '@belong/ui';
import clsx from 'clsx';
import css from './content-table-items.module.css';

type Subtitle = {
  href: string;
  name: string;
};

export type ContentTableItem = {
  href: string;
  name: string;
  subtitle?: Subtitle[];
};

type Props = {
  items: ContentTableItem[];
  onDismiss?: () => void;
};

export function ContentTableItems({ items, onDismiss }: Props) {
  return (
    <ul className="gap-sm flex flex-col">
      {items.map((item, index) => {
        return (
          <Text
            as="li"
            key={index}
            fontWeight="semibold"
            className={clsx('relative list-none', css.listItem)}
          >
            <LinkBase onClick={onDismiss} href={`#${item.href}`}>
              {item.name}
            </LinkBase>
            {item.subtitle && (
              <ol type="a" className="pl-md flex flex-col">
                {item.subtitle.map(({ name, href }, subIndex) => {
                  return (
                    <Text
                      variant="p1"
                      as="li"
                      key={subIndex}
                      className={clsx('mt-xs relative list-none', css.listItem)}
                    >
                      <LinkBase onClick={onDismiss} href={`#${href}`}>
                        {name}
                      </LinkBase>
                    </Text>
                  );
                })}
              </ol>
            )}
          </Text>
        );
      })}
    </ul>
  );
}
